((Drupal) => {
  Drupal.behaviors.ouigoBloc3ColonnesBlog = {
    attach: (context) => {
      const blocks = context.querySelectorAll('.bloc-3-colonnes-blog');

      blocks.forEach((block) => {
        const container = block.querySelector('.bloc-3-colonnes-blog__cards-container');
        const prevBtn = block.querySelector('.bloc-3-colonnes-blog__arrow--prev');
        const nextBtn = block.querySelector('.bloc-3-colonnes-blog__arrow--next');

        if (!container || !prevBtn || !nextBtn) return;

        const updateArrows = () => {
          const scrollLeft = container.scrollLeft;
          const maxScroll = container.scrollWidth - container.clientWidth;

          if (scrollLeft <= 5) {
            prevBtn.setAttribute('disabled', 'disabled');
          } else {
            prevBtn.removeAttribute('disabled');
          }

          if (scrollLeft >= maxScroll - 5) {
            nextBtn.setAttribute('disabled', 'disabled');
          } else {
            nextBtn.removeAttribute('disabled');
          }
        };

        const getScrollStep = () => {
          const firstCard = container.firstElementChild;
          const gap = 16;
          return firstCard ? firstCard.clientWidth + gap : 280;
        };

        prevBtn.addEventListener('click', () => {
          container.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
          container.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        container.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        updateArrows();
      });
    },
  };
})(Drupal);
